import React, { FC, useCallback, useMemo } from "react";
import { StyledAssetTypeFlag } from "./asset-type.styled";
import { Grid } from "@mui/material";

import {
    IconAudio,
    IconCaption,
    IconFile,
    IconImage,
    IconVideo,
    IconPhotoType,
    IconContentsVideo,
    IconCollection,
} from "@mzc-cloudplex/icons";
import { MEDIA_TYPES } from "@constants";
import theme from "@styles/theme";

const CollectionTypeFlag = ({ size }) => {
    const styleBySize = useMemo(() => {
        switch (size) {
            case "small":
                return { width: "20px", height: "16px", iconSize: "12px" };
            case "medium":
            default:
                return { width: "24px", height: "20px", iconSize: "16px" };
        }
    }, [size]);

    return (
        <StyledAssetTypeFlag
            sx={{
                width: styleBySize.width,
                height: styleBySize.height,
                color: theme.palette.constant.white,
                backgroundColor: theme.palette.etc.purple400,
            }}
        >
            <IconCollection size={styleBySize.iconSize} />
        </StyledAssetTypeFlag>
    );
};

export default CollectionTypeFlag;
